import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaToggleComponent } from './viva-toggle.component';

@NgModule({
  declarations: [
    VivaToggleComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    VivaToggleComponent
  ]
})
export class  VivaToggleModule { }
